export const BLOCKSCOUT_URL = 'https://blockscout.com/poa/xdai/address/'
